import React, { useEffect, useMemo, useRef, useState } from "react";
import Supplier from "../../lib/Core/Backend/Controllers/Supplier";
import CardType from "../../lib/Core/Backend/Controllers/CardType";
import Notify from "../../lib/Utils/Alert";
import ReactNotificationAlert from "react-notification-alert";
import {
	Button,
	Col,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
} from "reactstrap";
import Select from "react-select";
import DataTable from "../Core/DataTable";
import SkuMapping from "lib/Core/Backend/Controllers/SkuMapping";
import useCatalogs from "hooks/useCatalogs";
import Utils from "lib/Utils/Utils";
import "../../assets/scss/react/_buttons.scss"
import Spinner from 'react-bootstrap/Spinner';

const dollar = Intl.NumberFormat('en-US', {
		style: "currency",
		currency: "USD",
	});

const PurchaseForm = (props) => {
	const { token, name, openAlert,referenceValue,setReferenceValue,onDataLengthChange ,setShowData,supplierLabel,setSupplierLabel,brandId,setBrandId} = props;
	const {currencies} = useCatalogs();
	const supplierCtl = useMemo(() => new Supplier(token), [token]);
	const cardTypeCtl = useMemo(() => new CardType(token), [token]);
	const mappingsCtl = useMemo(() => new SkuMapping(token), [token]);

	
	const [cardTypeCatalog, setcardTypeCatalog] = useState([]);
	const [suppliers, setSuppliers] = useState([]);
	const [brands, setBrands] = useState([]);
	const [brandsLoading, setBrandsLoading] = useState(true);
	const [quantityInput, setQuantityInput] = useState(0);
	const [amountInput, setAmountInput] = useState(0);
	const [cardsLoading, setCardsLoading] = useState(true);
	const [cardTypes, setCardTypes] = useState([]);
	const [confirmModal, setConfirmModal] = useState(false);
	const [cardTypeRow, setCardTypeRow] = useState(null);
	const [date, setdate] = useState();
	const [purchaseTotal, setPurchaseTotal] = useState(0);
	const [purchaseSubtotal, setPurchaseSubtotal] = useState(0);
	const toggleConfirm = () => setConfirmModal(!confirmModal);
	const supplier = useRef();
	const alert = useRef();
	const table = useRef();
	const [showAmount, setShowAmount] = useState(false);
	const [deleteloading, setDeleteLoading] = useState(false)
	const [addOrdLoading, setAddOrdLoading] = useState(false)
	const brandSelect = useRef();
	const cardTypeSelect = useRef();

	const header = [
		{ title: "Name", data: "name", sortable: true, searchable: true },
		{
			title: "Discount",
			data: "purchaseDiscount",
			sortable: true,
			searchable: false,
			render: data => Utils.percentFormat(data/100)
		},
		{ title: "Fee", data: "purchaseFee", sortable: true, searchable: false, render: data => dollar.format(data)},
		{
			title: "Value",
			data: "amount",
			sortable: true,
			searchable: false,
			render: data => dollar.format(data)
		},
		{
			title: "Quantity",
			data: "quantity",
			sortable: true,
			searchable: false,
		},
		{
			title: 'Currency',
			data: 'currency',
			sortable: true,
			searchable: false,
		},
		{
			title: 'Subtotal Face Value',
			data: 'subtotal',
			sortable: true,
			render: data => dollar.format(data)
		},
		{
			title: 'Subtotal',
			data: 'total',
			sortable: true,
			render: data => dollar.format(data)
		}
	];

	const onRowCreated = (row) => {
		row.classList.add("ncentiva-datatable-row");
	};

	const onDraw = () => {
		if (table.current) {
			table.current.dataTable
				.rows()
				.eq(0)
				.each((i) => {
					const row = table.current.dataTable.row(i);
					const rowData = row.data();
					if (rowData) {
						let child = `<div class="row justify-content-between ml-1" id="order-${rowData.id}-detail" data-loaded="false">
							<div class="col-3" id="brand-${rowData.id}"><div class="row justify-content-center">Loading info...</div></div>
							<div class="col-4" id="cardType-${rowData.id}"><div class="row justify-content-center">Loading info...</div></div>
							<div class="col-3" id="amount-${rowData.id}"><div class="row justify-content-center">Loading info...</div></div>
                            <div class="col" id="quantity-${rowData.id}"><div class="row justify-content-center">Loading info...</div></div>
						</div>`;
						row.child(child).hide();
						row.child().addClass("ncentiva-datatable-child-row");
					}
				});
				if(table.current.dataTable.rows().data().toArray().length === 0){
					setPurchaseSubtotal('$0.00')
					setPurchaseTotal('$0.00');
				}
				onDataLengthChange(table.current.dataTable.rows().data().toArray().length);
		}
	};

	useEffect(() => {
		supplierCtl.all((data) => {
			if (data && !data.error) {
				setSuppliers(
					data.map((purchaser) => ({
						value: purchaser.id,
						label: purchaser.name,
					}))
				);
			} else {
				Notify(alert, "danger", data.errorMessage ?? data.error);
			}
		});
	}, []);

	const getData = (e) => {
		supplierCtl.getPurchaserOrderById(
			e.value,
			(data) => {
				if (data && !data.error) {
					setPurchaseSubtotal(dollar.format(data.subtotal))
					setPurchaseTotal(dollar.format(data.totalAmount));
					let purchaseItems = data.items.map(item => {
						let card = cardTypeCatalog.find(cardtype => cardtype.id === item.giftCardTypeId)
						return {
							...item,
							name: card ? card.productName : `Not available`,
							currency: currencies.find(currency => item.currencyId === currency.id)?.code ?? 'N.A.'
						}
					})
					let brandIds = data.items.map(item=>item.brandId)
					setBrandId(brandIds)
					setShowData(purchaseItems)
					table.current.dataTable.clear().rows.add(purchaseItems).draw();
				}
			});
	}

	const handleSupplierChange = (e) => {
		setSupplierLabel(e.label)
		setBrandsLoading(true);
		brandSelect.current.clearValue();
		setBrands([]);

		setCardsLoading(true);
		cardTypeSelect.current.clearValue();

		getData(e)

			supplierCtl.brands(e.value, (data) => {
				if (data && data.length > 0 && !data.error){
					const sortedBrands = data
					.filter(brand => brand.brand && brand.brand.name) 
					.sort((a, b) => a.brand.name.localeCompare(b.brand.name))
					.map((brand) => ({
					  label: brand.brand.name,
					  value: brand.brand.id,
					  supplierBrandId: brand.id,
					  fee: brand.purchaseFee,
					  discount: brand.purchaseDiscount
					}));
					
				  setBrands(sortedBrands);
					// setBrands(data
					// 	.sort((a, b) => a.brand.name.localeCompare(b.brand.name))
					// 		.map(
					// 			(brand) => {
					// 				return {
					// 					label: brand.brand.name,
					// 					value: brand.brand.id,
					// 					supplierBrandId: brand.id,
					// 					fee: brand.purchaseFee,
					// 					discount: brand.purchaseDiscount
					// 				}
					// 			}
					// 		));
					setBrandsLoading(false);
				} else {
					if(data.errorCode === 'NOT_FOUND')
						openAlert('No brands available for this supplier');
					else
						openAlert(data.errorMessage)
					setBrands([]);
				}
			})
	};

	const handleBrandChange = (e) => {
		setBrandId(e?.supplierBrandId);
		setCardsLoading(true);
		cardTypeSelect.current.clearValue();

		if (e) {
			let selectedSupplier = supplier.current.getValue()[0]
			supplierCtl.cardsByBrandBySupplier(selectedSupplier.value, e.supplierBrandId, data => {
				if(data.error || data.errorMessage){
					Notify(alert, 'danger', 'No Cards found for this brand')
				} else {
					mappingsCtl.mappingsBySupplier(selectedSupplier.value, mappingsData => {
						if(mappingsData.error || mappingsData.errorMessage){
							Notify(alert, 'danger', 'No Cards found for this brand')
						} else {
							let mappedCards = mappingsData.map(map => map.giftCardTypeId)
							let cardTypesTmp = data.filter(card => mappedCards.includes(card.giftCardTypeId))
							cardTypesTmp = cardTypesTmp.map(card => {
								let giftCard = cardTypeCatalog.find(cardType => card.giftCardTypeId === cardType.id)
								if(!!giftCard){
									return {
										value: giftCard.id,
										label: giftCard.productName,
										amount: giftCard.amount
									}
								} else {
									return null
								}
							})
							setCardTypes(cardTypesTmp.filter(card => !!card))
							setCardsLoading(false)
						}
					})
				}
			})
		}
	};

	const handleCardTypeChange = (e) => {
		if ((e === null) | (e === undefined)) {
			return;
		}
		setShowAmount(e.amount === 0);
	};

	const handlePurchaseChange = (e) => {
		if (e.target.name === "amount") {
			setAmountInput(parseFloat(e.target.value, 10));
		} else if (e.target.name === "quantity") {
			setQuantityInput(parseInt(e.target.value, 10));
		}
	};
	const addOrderLoading=()=>{
		setTimeout(()=>{
            setAddOrdLoading(false)
          }, 1500)
	}
	const addToPurchaseOrder = (e) => {
		e.preventDefault();
		setAddOrdLoading(true)
		if (showAmount && amountInput <= 0) {
			Notify(alert, "danger", `Value must be greater than 0`);
			addOrderLoading()
			return;
		}

		if (quantityInput <= 0) {
			Notify(alert, "danger", `Quantity must be greater than 0`);
			addOrderLoading()
			return;
		}

		supplierCtl.addPurchaserOrder(
			{ 
				giftCardTypeId: cardTypeSelect.current.getValue()[0].value,
				amount: amountInput,
				quantity: quantityInput,
				orderReference: referenceValue
			 },
			(data) => {
				if (data && !data.error) {
					setPurchaseSubtotal(dollar.format(data.subtotal))
					setPurchaseTotal(dollar.format(data.totalAmount));
					let purchaseItems = data.items.map(item => {
						let card = cardTypeCatalog.find(cardtype => cardtype.id === item.giftCardTypeId)
						return {
							...item,
							name: card ? card.productName : `Not available`,
							currency: currencies.find(currency => item.currencyId === currency.id)?.code ?? 'USD'
						}
					})
					let brandIds = data.items.map(item => item.brandId)
					setBrandId(brandIds)
					setShowData(purchaseItems)
					table.current.dataTable.clear().rows.add(purchaseItems).draw();
				} else {
					Notify(alert, "danger", data.errorMessage ?? data.error);
					addOrderLoading()
				}
				addOrderLoading()
			}
		);
	}

	const removeCardType = (row) => {
		setCardTypeRow(row);
		toggleConfirm();
	};
	function deleteLoad(){
		setTimeout(()=>{
            setDeleteLoading(false)
          }, 1500)
	}
	function confirmDelete() {
		const item = cardTypeRow.data();
		setDeleteLoading(true)
		supplierCtl.removePurchaserOrderById(item.id, (data) => {
			if (data && !data.error) {
				toggleConfirm();
				deleteLoad()
				getData(supplier.current.getValue()[0])
				Notify(
					alert,
					"success",
					`Item ${item.name} removed from shopping cart`
				);
			} else {
				Notify(alert, "danger", data.errorMessage ?? data.error);
				deleteLoad()
			}
		});
	}

	useEffect(() => {
		let today = new Date();
		let dd = String(today.getDate()).padStart(2, "0");
		let mm = String(today.getMonth() + 1).padStart(2, "0");
		let yyyy = today.getFullYear();

		today = mm + "-" + dd + "-" + yyyy;
		setdate(today);
		onDraw()
	}, []);

	useEffect(() => {
		cardTypeCtl.all(data => {
			if(data.error || data.errorMessage){
				setcardTypeCatalog([])
			} else {
				setcardTypeCatalog(data)
			}
		})
	}, [cardTypeCtl]);

	const handleReferenceValue = (e) =>{
		const newValue = e.target.value;
		setReferenceValue(newValue);
	}

	return (
		<>
			<ReactNotificationAlert ref={alert} />
			<Row className="justify-content-center">
				<Col md={5}>
					<legend className="text-center">{name}</legend>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col md={5}>
					<legend className="text-center">{date}</legend>
				</Col>
			</Row>
			<Row className="justify-content-center mt-5">
				<Col md="5">
					<FormGroup>
						<Label for="purchaseFormBrand">Supplier</Label>
						<Select
							id="purchaseFormBrand"
							ref={supplier}
							options={suppliers}
							onChange={handleSupplierChange}
						/>
					</FormGroup>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col md="5">
					<FormGroup>
						<Label for="purchaseOrderRefernce">Reference Id </Label>
						<Input
							id="purchaserOrder"
							type="text"
							name="amount"
							value={referenceValue}
							onChange={handleReferenceValue}
							/>
					</FormGroup>
				</Col>
			</Row>
			<Row className="justify-content-center mt-5">
				<Col md={3}>
					<FormGroup>
						<Label for="purchaseFormBrand">Brand</Label>
						<Select
							id="purchaseFormBrand"
							ref={brandSelect}
							options={brands}
							onChange={handleBrandChange}
							isLoading={brandsLoading}
						/>
					</FormGroup>
				</Col>

				<Col md={3}>
					<FormGroup>
						<Label for="purchaseFormCardType">Card Type</Label>
						<Select
							id="purchaseFormCardType"
							ref={cardTypeSelect}
							options={cardTypes}
							onChange={handleCardTypeChange}
							isLoading={cardsLoading}
						/>
					</FormGroup>
				</Col>
				{showAmount && (
					<Col md={2}>
						<FormGroup>
							<Label for="purchaseFormAmount">Value</Label>
							<Input
								id="purchaseFormAmount"
								type="number"
								name="amount"
								value={amountInput}
								onChange={handlePurchaseChange}
							/>
						</FormGroup>
					</Col>
				)}

				<Col md={2}>
					<FormGroup>
						<Label for="purchaseFormQuantity">Quantity</Label>
						<Input
							id="purchaseFormQuantity"
							type="number"
							name="quantity"
							value={quantityInput}
							onChange={handlePurchaseChange}
						/>
					</FormGroup>
				</Col>

				<Col md='auto'>
					<FormGroup className="mt-1">
						<Button
							className="mt-4 btn btn-primaryTwo"
							id="add-btn"
							type="button"
							onClick={addToPurchaseOrder}
							disabled={addOrdLoading}
						>
							{!addOrdLoading && "Add"} {addOrdLoading && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}
						</Button>
					</FormGroup>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col md="10" className="text-center">
				<div className="table-responsive">
					<DataTable
						className="mb-0 no-bottom-radius"
						options={{
							createdRow: onRowCreated,
							drawCallback: onDraw,
							saveState: false,
							dom: 'tr'
						}}
						ref={table}
						columns={header}
						data={null}
						enableSelectFilters={true}
						addRemoveButton={{ callback: removeCardType, viewMode: false }}
					/>
					</div>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<div className="col-sm-10">
					<div className="bg-color7 rounded-bottom pr-1" style={{width: "100%", height: "100%"}}>
						<p className="py-3 my-0 mr-5 pr-5 text-right"><span className="mr-4 font-weight-bold">subtotal</span>{purchaseSubtotal}</p>
						<p className="py-3 my-0 mr-5 pr-5 text-right"><span className="mr-4 font-weight-bold">Total</span>{purchaseTotal}</p>
					</div>
				</div>
			</Row>

			<Modal
				isOpen={confirmModal}
				toggle={toggleConfirm}
				backdrop="static"
				centered={true}
			>
				<ModalHeader className="custom_header_colourTwo" toggle={toggleConfirm}>
					Remove Card Type
				</ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to remove the selected card?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button type="button" color="secondary" onClick={toggleConfirm}>
						Cancel
					</Button>{" "}
					<Button type="button"  className="btn btn-primaryTwo" onClick={confirmDelete} disabled={deleteloading}>
						{!deleteloading && "Yes"}{deleteloading && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}
					</Button>
				</ModalFooter>
			</Modal>
		</>
	);
};

export default PurchaseForm;